import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={{ fontFamily: 'Lato', padding: '2rem' }}>
      <section>
        <h2>Cardacademy - Privacy Policy</h2>
        <p>Last updated: July 6, 2025</p>

        <p>
          This Privacy Policy outlines how Cardacademy ("we," "our," or "us")
          collects, uses, and protects your information when you visit or use
          our website <b>cardacademy.co.in</b>.
        </p>

        <h2>1. What Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>
            <strong>Personal Information:</strong> Name, email address, and
            contact details when you subscribe to our newsletter or contact us.
          </li>
          <li>
            <strong>Non-Personal Information:</strong> Browser type, device
            information, location data, IP address, and how you use our website
            (through cookies or analytics tools).
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect for the following purposes:</p>
        <ul>
          <li>
            To send you updates, newsletters, and promotional content (only if
            you opt-in).
          </li>
          <li>To improve our website, content, and user experience.</li>
          <li>
            To analyze trends and understand how users interact with our
            content.
          </li>
          <li>To respond to your inquiries or feedback.</li>
        </ul>

        <h2>3. Cookies and Tracking</h2>
        <p>
          We use cookies and similar technologies to enhance your browsing
          experience and collect usage data. You may choose to disable cookies
          through your browser settings, but some features of the site may not
          function properly.
        </p>

        <h2>4. Third-Party Services</h2>
        <p>
          We may use third-party tools like Google Analytics, Google Ads, or
          affiliate networks to understand user behavior or track affiliate
          activity. These services may collect data in accordance with their own
          privacy policies.
        </p>

        <h2>5. Affiliate Links</h2>
        <p>
          Some links on Cardacademy are affiliate links, meaning we may earn a
          commission if you click and apply for a product. This comes at no
          additional cost to you and does not influence our editorial content.
        </p>

        <h2>6. Data Protection</h2>
        <p>
          We implement reasonable technical and organizational measures to
          protect your information. However, no method of transmission over the
          Internet or method of electronic storage is 100% secure. We cannot
          guarantee absolute security.
        </p>

        <h2>7. Sharing of Information</h2>
        <p>
          We do not sell, rent, or trade your personal information with third
          parties. We may share limited data with partners for operational
          purposes (e.g., email delivery, analytics), but only under
          confidentiality agreements.
        </p>

        <h2>8. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal data we hold about you</li>
          <li>Request correction or deletion of your data</li>
          <li>Withdraw consent to receive marketing communications</li>
          <li>Request a copy of your data in a portable format</li>
        </ul>
        <p>
          To exercise your rights, please email us at{' '}
          <b>joincardacademy@gmail.com</b>.
        </p>

        <h2>9. Children's Privacy</h2>
        <p>
          Cardacademy is not intended for individuals under the age of 18. We do
          not knowingly collect personal information from children. If you
          believe we have accidentally collected such data, please contact us
          immediately.
        </p>

        <h2>10. Changes to This Privacy Policy</h2>
        <p>
          We reserve the right to modify this Privacy Policy at any time. Any
          changes will be posted on this page with a new "Last updated" date. We
          encourage you to review this page periodically.
        </p>

        <h2>11. Contact Us</h2>
        <p>
          If you have any questions, concerns, or complaints regarding our
          Privacy Policy, please contact us at:
        </p>
        <p>
          <b>Email:</b> joincardacademy@gmail.com
        </p>
      </section>
    </div>
  );
}
